export default __webpack_public_path__ + "static/Manrope-Variable-cb0ba3ba521ea0e0b60f1d364eabd07c.woff2";